import { Tool, Web3DViewer } from '@technology/web3d';
import { Web3dTool } from '@trimble/web3d-providers';

const navigationTools = [
  Web3dTool.AlignmentNavigation,
  Web3dTool.CameraShortcuts,
  Web3dTool.Fly,
  Web3dTool.Orbit,
  Web3dTool.Pan,
  Web3dTool.PanoramaControls,
  Web3dTool.PlanarControls,
  Web3dTool.Zoom,
] as const;

export type NavigationTool = (typeof navigationTools)[number];

export function enableTools(
  viewer: Web3DViewer,
  requiredTools: NavigationTool[] | null
): void {
  if (requiredTools == null) {
    return;
  }

  for (const toolName of navigationTools) {
    // Active tool should be disabled explicitly
    if (toolName === viewer.activeTool) {
      continue;
    }
    const tool = viewer?.tools?.[toolName] as Tool;
    if (!tool) {
      continue;
    }
    const shouldBeEnabled = requiredTools.includes(toolName);
    if (tool.enabled !== shouldBeEnabled) {
      tool.enabled = shouldBeEnabled;
    }
  }
}
